import BaseService from "./base.service";
import http from "../http-common";

class DocumentStorageService extends BaseService {
  constructor() {
    super("document-storage");
  }

  deleteFile({ sourceModel, source }) {
    return http.get(`${this.path}/deleteFile/${sourceModel}/${source}`);
  }
  getByEmployer(EmployerId) {
    const params = {
      userQuerySource: localStorage.getItem("userId"),
      enterpriseId: localStorage.getItem("enterpriseId")
    }
    return http.get(`document-storage/findByEmployer/${EmployerId}`, { params });
  }
  getAllDocsByEmployer(EmployerId) {
    const params = {
      userQuerySource: localStorage.getItem("userId"),
      enterpriseId: localStorage.getItem("enterpriseId")
    }
    return http.get(`document-storage/getAllDocsByEmployer/${EmployerId}`, { params });
  }
  getDocRHByEmployer(EmployerId) {
    const params = {
      userQuerySource: localStorage.getItem("userId"),
      enterpriseId: localStorage.getItem("enterpriseId")
    }
    return http.get(`document-storage/findDocRHByEmployer/${EmployerId}`, { params });
  }
  /**
   * 
   * @param {*} body
   *   { employerId, parentKey, update } 
   */
  updateFolderWithChildsByKey(body) {
    return http.post(`${this.path}/update-folder-with-childs`, body)
  }
  getParentByKey({ key, employerId }) {
    return http.get(`${this.path}/getByKey/${key}/${employerId}`);
  }
  updateById(data) {
    return http.put(`${this.path}/update/${data._id}`, data);
  }
  getByDocumentId(idDocument) {
    return http.get(`${this.path}/findByDocumentId/${idDocument}`);
  }

  getDefaultFolders(enterpriseId) {
    return http.get(`${this.path}/getDefaultFolders/${enterpriseId}`);
  }
  injectDefaultFolder(id) {
    return http.post(`${this.path}/default-folders/${id}/inject`);
  }
  removeEmptyDefaultFolder(id) {
    return http.post(`${this.path}/default-folders/${id}/remove-empty`);
  }
}

export default new DocumentStorageService();
